module.exports = __webpack_public_path__ + "static/media/bills-icon.e9033359.png";